/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.TOUCHWIZ_MODELS = {
    'GT-B5310!'                                 : [ 'Samsung', 'Corby Pro' ],
    'GT-B3410'                                  : [ 'Samsung', 'Star Qwerty' ],
    'GT-B7722'                                  : [ 'Samsung', 'Star Duos' ],
    'GT-C3262'                                  : [ 'Samsung', 'Champ Neo Duos' ],
    'GT-C33(00|03)!'                            : [ 'Samsung', 'Champ' ],
    'GT-C3312R'                                 : [ 'Samsung', 'Rex 60' ],
    'GT-C3312!'                                 : [ 'Samsung', 'Champ Deluxe Duos' ],
    'GT-C3330'                                  : [ 'Samsung', 'Champ 2' ],
    'GT-C6712'                                  : [ 'Samsung', 'Star II Duos' ],
    'GT-E2652!'                                 : [ 'Samsung', 'Champ Duos' ],
    'GT-I6230!'                                 : [ 'Samsung', 'Star TV' ],
    'GT-I6712!'                                 : [ 'Samsung', 'Duos TV' ],
    'GT-M3710'                                  : [ 'Samsung', 'Corby Beat' ],
    'GT-M5650'                                  : [ 'Samsung', 'Lindy' ],
    'GT-S3370!'                                 : [ 'Samsung', 'Corby 3G' ],
    'GT-S36(50|53)!'                            : [ 'Samsung', 'Corby' ],
    'GT-S3770!'                                 : [ 'Samsung', 'Champ 3G' ],
    'GT-S38(00|02)!'                            : [ 'Samsung', 'Rex 70' ],
    'GT-S3850'                                  : [ 'Samsung', 'Corby II' ],
    'GT-S5220'                                  : [ 'Samsung', 'Star 3' ],
    'GT-S5222R'                                 : [ 'Samsung', 'Rex 80' ],
    'GT-S5222'                                  : [ 'Samsung', 'Star 3 Duos' ],
    'GT-S52(30|33)!'                            : [ 'Samsung', 'Star' ],
    'GT-S5260P'                                 : [ 'Samsung', 'Player City' ],
    'GT-S52(60|63)!'                            : [ 'Samsung', 'Star II' ],
    'GT-S5292R'                                 : [ 'Samsung', 'Rex 90' ],
    'GT-S5292'                                  : [ 'Samsung', 'Star Deluxe Duos' ],
    'GT-S5560!'                                 : [ 'Samsung', 'Marvel' ],
    'GT-S5600'                                  : [ 'Samsung', 'Preston' ],
    'GT-S5603'                                  : [ 'Samsung', 'Star 3G' ],
    'GT-S5620!'                                 : [ 'Samsung', 'Monte' ],
    'GT-S5680'                                  : [ 'Samsung', 'GT-S5680' ],
    'GT-S7550'                                  : [ 'Samsung', 'Blue Earth' ],
    'S80(00|03)!'                               : [ 'Samsung', 'Jet' ],
    'GT-S8000c'                                 : [ 'Samsung', 'Jet' ],
    'GT-S8003'                                  : [ 'Samsung', 'Jet' ],
    'SGH-A597'                                  : [ 'Samsung', 'Eternity II' ],
    'SGH-F480'                                  : [ 'Samsung', 'Tocco' ],
    'SGH-F480I'                                 : [ 'Samsung', 'Tocco' ],
    'SGH-T528g'                                 : [ 'Samsung', 'Straight Talk' ]
};

/* This file is automatically generated, do not edit manually! */
